import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

export class PaypalSuccessController implements ng.IController {

    static $inject: string[] = [
        '$state',
        '$stateParams',
        '$scope',
        'store',
        'ArchiSmallServices',
        '$rootScope',
        '$location',
        '$timeout'
    ];

    constructor(
        private $state: ng.ui.IStateService,
        private $stateParams: any,
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $rootScope: any,
        private $location: ng.ILocationService,
        private $timeout: ng.ITimeoutService
    ) {

        let paymill_trx_id = $location.search().paymill_trx_id;
        if (paymill_trx_id !== undefined && paymill_trx_id !== '') {
            // case of paypal success callback
            let paypal_trx_id = $location.search().paypal_trx_id;
            //  var paymill_trx_id = $location.search().paymill_trx_id;
            let paymill_trx_status = $location.search().paymill_trx_status;
            let paymill_response_code = $location.search().paymill_response_code;
            let paymill_mode = $location.search().paymill_response_code;
            ArchiSmallServices.validateTransaction(paymill_trx_id)
                .then((response: any) => {
                    switch (response.status) {
                        case 'closed':
                            $scope.user.paymentResponse = response;
                            break;
                        case 'failed':
                            $timeout(() => {
                                $scope.errorMessage = response.response_code + ' : ' + response.responseCodeDetail;
                                $scope.isDisabled = false;
                            });
                            break;
                        case 'pending':
                            $timeout(() => {
                                $scope.errorMessage = response.response_code + ' : ' + response.responseCodeDetail;
                                $scope.isDisabled = false;
                            });
                            break;
                        default:
                            $timeout(() => {
                                $scope.errorMessage = 'Unexpected response status : ' + response.status;
                                $scope.isDisabled = false;
                            });
                            break;
                    }
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/paypal-success/paypal-success.controller.ts